export default "__VITE_ASSET__BdRv$1m2__"